export function promiseAnyPolyfill() {
  if (!Promise.any) {
    Promise.any = function <T>(promises: Array<Promise<T>>): Promise<T> {
      return new Promise<T>((resolve, reject) => {
        const errors: any[] = [];
        let pendingPromises = promises.length;

        // Check if the input is iterable
        if (pendingPromises === 0) {
          return reject(new AggregateError([], "All promises were rejected"));
        }

        promises.forEach((promise, index) => {
          Promise.resolve(promise)
            .then(resolve) // Resolve as soon as any promise resolves
            .catch((error) => {
              errors[index] = error;
              pendingPromises--;

              if (pendingPromises === 0) {
                reject(new AggregateError(errors, "All promises were rejected"));
              }
            });
        });
      });
    };
  }
}
